import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CachedProduct {
  data: any;
  timestamp: number;
}

interface ProductState {
  cachedProducts: Record<string, CachedProduct>;
}

const initialState: ProductState = {
  cachedProducts: {},
};

const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setCachedProduct: (state, action: PayloadAction<{ productId: string; productData: any }>) => {
      const { productId, productData } = action.payload;
      state.cachedProducts[productId] = {
        data: productData,
        timestamp: Date.now(),
      };
    },
    removeCachedProduct: (state, action: PayloadAction<string>) => {
      delete state.cachedProducts[action.payload];
    },
    clearProductCache: (state) => {
      state.cachedProducts = {};
    },
    initializeProductCache: (state, action: PayloadAction<Record<string, CachedProduct>>) => {
      state.cachedProducts = action.payload;
    },
  },
});

export const { setCachedProduct, removeCachedProduct, clearProductCache, initializeProductCache } =
  productSlice.actions;

export default productSlice.reducer;
